"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsContext = void 0;

var react_1 = __importStar(require("react"));

var spaui_utils_1 = require("@tencent/spaui-utils");

var StepsPanel_1 = __importDefault(require("./StepsPanel"));

var StepsData_1 = __importDefault(require("./StepsData"));

var classnames_1 = __importDefault(require("classnames"));

exports.StepsContext = react_1["default"].createContext(0);

var Steps = function Steps(props, ref) {
  var _a;

  var children = props.children,
      _b = props.current,
      current = _b === void 0 ? 0 : _b,
      onChange = props.onChange,
      _c = props.StepsPanelComponent,
      StepsPanelComponent = _c === void 0 ? StepsPanel_1["default"] : _c,
      //eslint-disable-line
  _d = props.StepsDataComponent,
      //eslint-disable-line
  StepsDataComponent = _d === void 0 ? StepsData_1["default"] : _d,
      //eslint-disable-line
  IconComponent = props.IconComponent,
      //eslint-disable-line
  _e = props.direction,
      //eslint-disable-line
  direction = _e === void 0 ? 'horizontal' : _e,
      iconSet = props.iconSet,
      lineStyleSet = props.lineStyleSet,
      lineSize = props.lineSize,
      lineColor = props.lineColor,
      lineLong = props.lineLong,
      lineGap = props.lineGap,
      lineRadius = props.lineRadius,
      labelProps = props.labelProps,
      descProps = props.descProps,
      style = props.style,
      iconColor = props.iconColor,
      iconDoingColor = props.iconDoingColor,
      iconGap = props.iconGap,
      iconSize = props.iconSize,
      infoMargin = props.infoMargin,
      infoClassName = props.infoClassName,
      restProps = __rest(props, ["children", "current", "onChange", "StepsPanelComponent", "StepsDataComponent", "IconComponent", "direction", "iconSet", "lineStyleSet", "lineSize", "lineColor", "lineLong", "lineGap", "lineRadius", "labelProps", "descProps", "style", "iconColor", "iconDoingColor", "iconGap", "iconSize", "infoMargin", "infoClassName"]);

  var childrenList = react_1["default"].Children.toArray(children);
  var len = childrenList.length;
  var childrenListFinal = childrenList.map(function (item, idx) {
    return react_1["default"].createElement(StepsPanelComponent, __assign({
      key: idx,
      value: idx
    }, item.props, {
      IconComponent: IconComponent,
      StepsDataComponent: StepsDataComponent,
      direction: direction,
      iconSet: iconSet,
      lineStyleSet: lineStyleSet,
      labelProps: labelProps,
      descProps: descProps,
      total: len,
      index: idx,
      infoClassName: infoClassName
    }, restProps));
  });
  var previousRef = (0, react_1.useRef)(current);
  (0, react_1.useEffect)(function () {
    var previous = previousRef.current;

    if (previous !== current && onChange) {
      onChange(current, previous);
    }
  }, [current, onChange]);
  var isVertical = direction === 'vertical';

  var cssText = __assign((_a = {}, _a['--steps-info-m'] = (0, spaui_utils_1.pxVal)(infoMargin), _a['--steps-line-size'] = (0, spaui_utils_1.pxVal)(lineSize), _a['--steps-line-color'] = lineColor, _a['--steps-icon-color'] = iconColor, _a['--steps-icon-doing-color'] = iconDoingColor, _a['--steps-line-long'] = (0, spaui_utils_1.pxVal)(lineLong), _a['--steps-line-radius'] = (0, spaui_utils_1.pxVal)(lineRadius), _a['--steps-icon-size'] = (0, spaui_utils_1.pxVal)(iconSize), _a['--steps-icon-my'] = isVertical ? (0, spaui_utils_1.pxVal)(iconGap) : undefined, _a['--steps-icon-mx'] = !isVertical ? (0, spaui_utils_1.pxVal)(iconGap) : undefined, _a['--steps-line-my'] = isVertical ? (0, spaui_utils_1.pxVal)(lineGap) : undefined, _a['--steps-line-mx'] = !isVertical ? (0, spaui_utils_1.pxVal)(lineGap) : undefined, _a), style);

  return react_1["default"].createElement(exports.StepsContext.Provider, {
    value: current
  }, react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    withDefaultClassName: false,
    className: (0, classnames_1["default"])('odc-steps flex', {
      'flex-column odc-steps-vertical': isVertical
    }),
    supportAllEvents: true,
    ref: ref
  }, Steps), {
    style: (0, spaui_utils_1.removeUndefined)(cssText)
  }), childrenListFinal));
};

exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Steps));